const ANALYTICS = 'analytics'
const BANNER_LOAD = 'cookieyes_banner_load'
const CONSENT_UPDATE = 'cookieyes_consent_update'

function analyticsAccepted(consent) {
  return consent?.categories?.[ANALYTICS] === true
}

function onAnalyticsConsent(callback) {
  const handleBannerLoad = (event) => callback(analyticsAccepted(event.detail))
  const handleConsentUpdate = (event) => callback(Boolean(event.detail?.accepted?.includes(ANALYTICS)))

  document.addEventListener(BANNER_LOAD, handleBannerLoad)
  document.addEventListener(CONSENT_UPDATE, handleConsentUpdate)

  if (typeof window.getCkyConsent === 'function') {
    callback(analyticsAccepted(window.getCkyConsent()))
  }

  return () => {
    document.removeEventListener(BANNER_LOAD, handleBannerLoad)
    document.removeEventListener(CONSENT_UPDATE, handleConsentUpdate)
  }
}

export { onAnalyticsConsent }
